<template>
  <div class="flex flex-wrap mb-3" :class="{ 'iframe-mode': isInIframe }">
    <div
      :class="primaryTextClass"
      class="text-zt-xl w-full pt-10"
      v-if="
        userCanApproveLicenses &&
          (windowResize.width > 1024 || isInIframe) &&
          (isInIframe || userIsApprovingProfile)
      "
    >
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <button
            class="h-8 w-8 back-button"
            @click="goBack()"
            v-on="on"
            data-vs-button="toLicenceManager"
          >
            <zt-icon name="arrow-left" class="pb-2 mt-1 pr-1" :class="primaryTextClass" />
          </button>
        </template>
        <span>{{ $t('message.LicensesManager.goBack') }}</span>
      </v-tooltip>
      <span class="ml-1">{{
        $t('message.licenseComponent.licenseBox.requestLicense')
      }}</span>
    </div>
    <div
      class="lg:px-6 lg:w-1/3 md:p-4 md:px-6 md:w-1/3 sm:w-full w-full xl:px-6 xl:w-1/4 xs:w-full"
    >
      <RequestProcess @change-step="changeStep" />
    </div>
    <div
      class="w-full xs:w-full sm:w-full md:w-2/3 lg:w-2/3 xl:w-3/4 lg:px-4 xl:px-4"
      v-if="
        (windowResize.width < 1024 && requestStep == 0) ||
          windowResize.width >= 1024
      "
    >
      <template v-if="userCanApproveLicenses && windowResize.width < 1024">
        <v-tabs fixed-tabs slider-color="#F16B6C" class="ml-0">
          <v-tab class="" v-for="n in 1" :key="n" @click="licenseTab = n" data-vs-button="changeTab">
            <span
              :class="
                licenseTab === 1 ? primaryTextClass : 'text-zt-dark-400' 
              "
              class="text-left"
              v-if="n === 1"
              >{{
                $t('message.LicensesHistoryComponent.tabs.licenses.title')
              }}</span
            >
            <span
              :class="
                licenseTab === 2 ? primaryTextClass : 'text-zt-dark-400'
              "
              v-if="n === 2"
            >
              {{
                $t(
                  'message.LicensesHistoryComponent.tabs.licensesForApproval.licensesPending'
                )
              }}
            </span>
          </v-tab>
        </v-tabs>
        <History v-if="licenseTab === 1" :showTitle="!userCanApproveLicenses" />
        <PendingApprovalMobile v-if="licenseTab === 2" />
      </template>
      <template v-else>
        <History />
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import RequestProcess from '../components/request/RequestProcess'
import History from '../components/request/History'
import PendingApprovalMobile from '../components/pending/PendingApprovalMobile'
import { useWindowResize } from '@sichern/ui-elements'
import { state, mutations } from '../components/Observables/useLicenseHistory'

export default {
  components: {
    RequestProcess,
    History,
    PendingApprovalMobile
  },
  provide: { state, mutations },
  data() {
    return {
      requestStep: 0,
      userCanApproveLicenses: false,
      licenseTab: 1,
      windowResize: useWindowResize(this),
      userIsApprovingProfile: true
    }
  },
  computed: {
    ...mapGetters(['getActions', 'getUser']),
    isInIframe() {
      return this.$iframeMessages && this.$iframeMessages.isTokenValid();
    },
    primaryTextClass() {
      return this.isInIframe ? 'text-iframe-primary' : 'text-zt-primary-200';
    },
    primaryColor() {
      return this.isInIframe ? '#2694fc' : '#4f41a3';
    }
  },
  created() {
    this.userIsApprovingProfile = false
    window.scrollTo(0, 0)
    const actions = this.getActions
    for (let key in actions) {
      if (actions[key].id === '71') {
        this.userCanApproveLicenses = true
        break
      }
    }
    const user = this.getUser
    user.perfiles.forEach(profile => {
      if (profile.id_perfil_tipo === 5) {
        this.userIsApprovingProfile = true
      }
    })
  },
  methods: {
    changeStep(step) {
      this.requestStep = step
    },
    goBack() {
      this.$route.params.routerGo === 'manager' ? this.$router.push('/manager-licenses-page') : this.$router.push('/licenses-manager')
    },
  }
}
</script>

<style lang="scss" scoped>
.back-button:hover {
  background-color: #e0e0e0;
  border-radius: 9999px;
}
::v-deep  .v-tabs__div{
  margin-left: 0.75rem !important;
  width: 350px !important;
  margin-right: auto !important;
  
}

.text-iframe-primary {
  color: #2694fc !important;
}

.iframe-mode {
  ::v-deep .v-tabs__slider {
    background-color: #2694fc !important;
  }
}
</style>
